import React from "react";
import "./Datamanagement.css";
import storage from "../../../assets/products/storage.png";
import dashboard from "../../../assets/products/analytics.png";
import adoption from "../../../assets/products/adoption.png";

const Datamanagement = () => {
  const data = [
    {
      id: 1,
      title: "Data Storage",
      description:
        "We provide you a computer-vision and brain-signal data warehouse with an outcome-based, fully managed data infrastructure and integration services.",
      img: storage,
    },
    {
      id: 2,
      title: "Analytics Dashboard",
      description:
        "Data is only valuable if it's understandable. Our intuitive interfaces and customizable dashboards make data interpretation a breeze. Gain insights quickly, even if you're not a data expert.",
      img: dashboard,
    },
    {
      id: 3,
      title: "Analytics Adoption Program",
      description:
        "We don't just provide tools; we empower you with knowledge. Work with our dedicated data analytics coach and leverage best practices to achieve your goals.",
      img: adoption,
    },
  ];
  return (
    <section className="gray-background-bg d-flex justify-content-center">
      <div className="product-components-max-width">
        <h1 className="primary-light-text Facilitating-Data-Management">Facilitating Data Management</h1>
        {data.map((data) => (
          <div
            key={data.id}
            id="data-management-card"
            className="row insights-card"
          >
            <div className="col-lg-8 col-md-6">
              <h6 className="primary-light-text">{data.title}</h6>
              <p className="secondary-light-text">{data.description}</p>
            </div>
            <div className="col-lg-4 col-md-6">
              <img src={data.img} alt="" />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Datamanagement;
